import { enableRipple } from '@syncfusion/ej2-base'
import { FC, ReactElement } from 'react'
import styles from './MenuHeaderBar.module.scss'


enableRipple(true)

interface DynamicToolbarProps {
  headerContent: string
  contentLeft?: () => ReactElement
  contentRight?: () => ReactElement
}

export const MenuHeaderBar: FC<DynamicToolbarProps> = ({ headerContent, contentRight, contentLeft }) => {

  return (
    <>

      <div className={styles.menuHeaderBar}>
        <div style={{ flex: 1, marginLeft: '25px', display: 'flex', alignItems: 'center', gap: '20px' }}>{contentLeft && contentLeft()}</div>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <div className={styles.header}>{headerContent}</div>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', marginRight: '25px', gap: '20px' }}>{contentRight && contentRight()}</div>
        </div>
      </div>

    </>
  )
}
